module.exports = __webpack_public_path__ + "static/media/touch_icon_three.3e282298.svg";